import util from '@bmp-vue/core/api/util'

const controller = 'Scopes'
export default Object.assign({}, util.GetCrud(controller, null))
